// app分享相关,通过url scheme调用分享
import { reqUrlByIframe } from './util.url';
import { encodeBase64 } from './util.crypto';
import Env, { compareVersion } from './util.env.js';
import didasdk from './util.didasdk.js';
/**
 * 获取分享url scheme
 * @param title
 * @param detail
 * @param url
 * @param imgurl
 * @param noHttp
 * @returns {string}
 */

export function getShareUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      title = _ref.title,
      detail = _ref.detail,
      url = _ref.url,
      imgurl = _ref.imgurl;

  var share = {};
  share.t = title || '';
  share.d = detail || '';
  share.i = imgurl || '';
  share.u = url || '';
  return encodeBase64(JSON.stringify(share));
} // APP分享(app右下角分享按钮)

export function shareByAppBtn() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      title = _ref2.title,
      detail = _ref2.detail,
      url = _ref2.url,
      imgurl = _ref2.imgurl;

  // todo 区分出行App和司机App
  if (Env.inApplication) {
    // 出租车司机App 或 版本小于8.3.5 使用旧版分享
    if (Env.isDidaPinche && compareVersion(Env.curAppVersion, '8.3.5') < 0) {
      reqUrlByIframe('didapinche://menu?hide=0&sharekey=' + encodeURIComponent(getShareUrl({
        title: title,
        detail: detail,
        url: url
      })));
    } else if (Env.isDidaTaxi) {
      var shareData = getShareUrl({
        title: title,
        detail: detail,
        url: url
      });
      reqUrlByIframe('didataxi://menu?hide=0&sharekey=' + encodeURIComponent(shareData)); // 以下为兼容ios

      var elA = document.createElement('a');
      elA.href = 'http://n/' + shareData;
      elA.style.display = 'none';
      document.body.appendChild(elA);
    } else {
      // 使用jsbridge分享
      var sharedatah5 = {
        thumbnail: imgurl,
        title: title,
        des: detail,
        link: url,
        id: 'statusBarShare'
      };
      didasdk.ready(function () {
        didasdk.shareByAppBtn(sharedatah5);
      });
    }
  }
} // h5页面内按钮

export function shareByH5Btn() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      title = _ref3.title,
      detail = _ref3.detail,
      url = _ref3.url,
      imgurl = _ref3.imgurl;

  if (Env.inApplication) {
    // 出租车司机App 或 版本小于8.3.5 使用旧版分享
    if (Env.isDidaTaxi || compareVersion(Env.curAppVersion, '8.3.5') < 0) {
      window.location = 'http://n/' + getShareUrl({
        title: title,
        detail: detail,
        url: url
      });
    } else {
      // jsbridge 分享
      var sharedatah5 = {
        thumbnail: imgurl,
        title: title,
        des: detail,
        link: url,
        id: 'clickControlToShare'
      };
      didasdk.ready(function () {
        didasdk.shareByH5Btn(sharedatah5);
      });
    }
  }
}